import React from 'react'
import { Card, Image } from 'react-bootstrap'
import * as s from './EliminatorWinners.scss'
import { playerUrl } from '@severed-links/common.redherrings-constants'

const EliminatorWinnerPeople = ({ hasWinner, hasTie, seasonName, winners = [] }) => (
    (hasWinner || hasTie) && winners.length ?
    <Card.Body className={`${s.winnerPeople} ${s[`winnerCount${Math.min(winners.length, 3)}`]}`}>
    {winners.map(i =>
    <div className={s.winnerPerson} key={`winner-${seasonName}-${i.playerId}`}>
        <Image className={s.avatar} src={playerUrl(i.avatarUrl)} alt={`${i.firstName} ${i.lastName}`} />
        <div className={s.name}>{i.firstName} {i.lastName}</div>
    </div>
    )}
    </Card.Body>
    : null
)

export default EliminatorWinnerPeople
